export const initialState = {
  request: null,
  businessServiceCategories: [],
  loading: false,
  error: null,
  businessServiceCategory: {},
  serviceCategoryLoading: false,
  serviceCategoryError: null,
  businessServices: [],
  businessServicesLoading: false,
  businessServicesError: null,
  businessService: {},
  businessServiceLoading: false,
  businessServiceError: null,
  businessServiceOrders: [],
  businessServiceOrdersLoading: false,
  businessServiceOrdersError: null,
  businessServiceOrder: {},
  businessServiceOrderLoading: false,
  businessServiceOrderError: null,
  serviceOrderStatusUpdate: null,
  serviceOrderStatusUpdateLoading: false,
  serviceOrderStatusUpdateError: null,
  businessServiceID: "",
  businessServiceUpdateLoading: false,
  businessServiceUpdateError: null,
  businessServiceCreateLoading: false,
  businessServiceCreateError: null,
  serviceAddons: [],
  serviceAddonsLoading: false,
  serviceAddonsError: null,
  addOnId: "",
  updateServiceAddOnError: null,
  updateServiceAddOnLoading: false,
  newServiceAddOn: "",
  newServiceAddOnError: null,
  newServiceAddOnLoading: false,
  businessServiceDeleteLoading: false,
  businessServiceDeleteError: null,
  deletedID: "",
  deleteServiceAddOnError: null,
  deleteServiceAddOnLoading: false,
  deletedAddOnID: "",
  nextTokens: { 1: null },
  provinces: [],
  provincesLoading: false,
  provincesError: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "REQUEST_LIST_BUSINESS_SERVICE_CATEGORIES":
      return {
        ...state,
        request: action.payload.request,
        businessServiceCategories: [],
        nextTokens:
          action.payload.page === 1
            ? initialState.nextTokens
            : state.nextTokens,
        nextToken: null,
        loading: true,
        error: null,
      };
    case "LIST_BUSINESS_SERVICE_CATEGORIES_SUCCESS":
      return {
        ...state,
        businessServiceCategories: action.payload.businessServiceCategories,
        nextTokens: {
          ...state.nextTokens,
          [action.payload.nextPage]: action.payload.nextToken,
        },
        loading: false,
        request: null,
      };
    case "LIST_BUSINESS_SERVICE_CATEGORIES_CANCEL":
      return {
        ...state,
        loading: false,
        error: null,
        request: null,
      };
    case "LIST_BUSINESS_SERVICE_CATEGORIES_ERROR":
      return {
        ...state,
        loading: false,
        error: action.error,
        request: null,
      };
    case "REQUEST_GET_BUSINESS_SERVICE_CATEGORY":
      return {
        ...state,
        businessServiceCategory: {},
        serviceCategoryError: null,
        serviceCategoryLoading: true,
      };
    case "GET_BUSINESS_SERVICE_CATEGORY_SUCCESS":
      return {
        ...state,
        businessServiceCategory: action.payload.businessServiceCategory,
        serviceCategoryLoading: false,
      };
    case "GET_BUSINESS_SERVICE_CATEGORY_ERROR":
      return {
        ...state,
        serviceCategoryLoading: false,
        serviceCategoryError: action.error,
      };
    case "REQUEST_LIST_BUSINESS_SERVICES":
      return {
        ...state,
        request: action.payload.request,
        businessServices: [],
        nextTokens:
          action.payload.page === 1
            ? initialState.nextTokens
            : state.nextTokens,
        nextToken: null,
        businessServicesLoading: true,
        businessServicesError: null,
      };
    case "LIST_BUSINESS_SERVICES_SUCCESS":
      return {
        ...state,
        businessServices: action.payload.businessServices,
        nextTokens: {
          ...state.nextTokens,
          [action.payload.nextPage]: action.payload.nextToken,
        },
        businessServicesLoading: false,
        request: null,
      };
    case "LIST_BUSINESS_SERVICES_CANCEL":
      return {
        ...state,
        businessServicesLoading: false,
        businessServicesError: null,
        request: null,
      };
    case "LIST_BUSINESS_SERVICES_ERROR":
      return {
        ...state,
        businessServicesLoading: false,
        businessServicesError: action.error,
        request: null,
      };
    case "REQUEST_GET_BUSINESS_SERVICE":
      return {
        ...state,
        businessService: {},
        businessServiceError: null,
        businessServiceLoading: true,
      };
    case "GET_BUSINESS_SERVICE_SUCCESS":
      return {
        ...state,
        businessService: action.payload.businessService,
        businessServiceLoading: false,
      };
    case "GET_BUSINESS_SERVICE_ERROR":
      return {
        ...state,
        businessServiceLoading: false,
        businessServiceError: action.error,
      };
    case "REQUEST_LIST_BUSINESS_SERVICE_ORDER":
      return {
        ...state,
        request: action.payload.request,
        businessServiceOrders: [],
        nextTokens:
          action.payload.page === 1
            ? initialState.nextTokens
            : state.nextTokens,
        nextToken: null,
        businessServiceOrdersLoading: true,
        businessServiceOrdersError: null,
      };
    case "LIST_BUSINESS_SERVICE_ORDER_SUCCESS":
      return {
        ...state,
        businessServiceOrders: action.payload.businessServiceOrders,
        nextTokens: {
          ...state.nextTokens,
          [action.payload.nextPage]: action.payload.nextToken,
        },
        businessServiceOrdersLoading: false,
        request: null,
      };
    case "LIST_BUSINESS_SERVICE_ORDER_CANCEL":
      return {
        ...state,
        businessServiceOrdersLoading: false,
        businessServiceOrdersError: null,
        request: null,
      };
    case "LIST_BUSINESS_SERVICE_ORDER_ERROR":
      return {
        ...state,
        businessServiceOrdersLoading: false,
        businessServiceOrdersError: action.error,
        request: null,
      };
    case "REQUEST_GET_BUSINESS_SERVICE_ORDER":
      return {
        ...state,
        businessServiceOrder: {},
        businessServiceOrderError: null,
        businessServiceOrderLoading: true,
      };
    case "GET_BUSINESS_SERVICE_ORDER_SUCCESS":
      return {
        ...state,
        businessServiceOrder: action.payload.businessServiceOrder,
        businessServiceOrderLoading: false,
      };
    case "GET_BUSINESS_SERVICE_ORDER_ERROR":
      return {
        ...state,
        businessServiceOrderLoading: false,
        businessServiceOrderError: action.error,
      };
    case "REQUEST_UPDATE_SERVICE_ORDER_STATUS":
      return {
        ...state,
        request: action.payload.request,
        serviceOrderStatusUpdate: null,
        serviceOrderStatusUpdateLoading: true,
        serviceOrderStatusUpdateError: null,
      };
    case "UPDATE_SERVICE_ORDER_STATUS_SUCCESS":
      return {
        ...state,
        request: null,
        businessServiceOrder: {
          ...state.businessServiceOrder,
          status: action.payload.serviceOrderStatusUpdate.status,
          updatedAt: action.payload.serviceOrderStatusUpdate.updatedAt,
        },
        serviceOrderStatusUpdate: action.payload.serviceOrderStatusUpdate,
        serviceOrderStatusUpdateLoading: false,
      };
    case "UPDATE_SERVICE_ORDER_STATUS_ERROR":
      return {
        ...state,
        request: null,
        serviceOrderStatusUpdateLoading: false,
        serviceOrderStatusUpdateError: action.error,
      };
    case "REQUEST_UPDATE_BUSINESS_SERVICE":
      return {
        ...state,
        request: action.payload.request,
        businessServiceUpdateLoading: true,
        businessServiceUpdateError: null,
        businessServiceID: "",
      };
    case "UPDATE_BUSINESS_SERVICE_SUCCESS":
      const { businessService } = action.payload;
      const updatedBusinessServices = state.businessServices.map((item) =>
        item.id === businessService.id ? businessService : item
      );
      return {
        ...state,
        request: null,
        businessServiceUpdateLoading: false,
        businessServiceID: businessService.id,
        businessServices: updatedBusinessServices,
      };
    case "UPDATE_BUSINESS_SERVICE_ERROR":
      return {
        ...state,
        request: null,
        businessServiceUpdateLoading: false,
        businessServiceUpdateError: action.error,
      };
    case "REQUEST_CREATE_BUSINESS_SERVICE":
      return {
        ...state,
        request: action.payload.request,
        businessServiceCreateLoading: true,
        businessServiceCreateError: null,
        businessServiceID: "",
      };
    case "CREATE_BUSINESS_SERVICE_SUCCESS":
      return {
        ...state,
        request: null,
        businessServiceCreateLoading: false,
        businessService: action.payload.businessService,
        businessServiceID: action.payload.businessService.id,
        businessServices: [
          ...state.businessServices,
          action.payload.businessService,
        ],
      };
    case "CREATE_BUSINESS_SERVICE_ERROR":
      return {
        ...state,
        request: null,
        businessServiceCreateLoading: false,
        businessServiceCreateError: action.error,
      };
    case "REQUEST_DELETE_BUSINESS_SERVICE":
      return {
        ...state,
        request: action.payload.request,
        businessServiceDeleteLoading: true,
        businessServiceDeleteError: null,
        deletedID: "",
      };
    case "DELETE_BUSINESS_SERVICE_SUCCESS":
      return {
        ...state,
        request: null,
        businessServiceDeleteLoading: false,
        deletedID: action.payload.businessServiceID,
        businessServices: state.businessServices.filter(
          (businessService) =>
            businessService.id !== action.payload.businessServiceID
        ),
      };
    case "DELETE_BUSINESS_SERVICE_CANCEL":
      return {
        ...state,
        businessServiceDeleteLoading: false,
        businessServiceDeleteError: null,
        request: null,
      };
    case "DELETE_BUSINESS_SERVICE_ERROR":
      return {
        ...state,
        request: null,
        businessServiceDeleteLoading: false,
        businessServiceDeleteError: action.error,
      };
    case "REQUEST_LIST_AVAILABLE_ADD_ONS":
      return {
        ...state,
        request: action.payload.request,
        serviceAddons: [],
        nextTokens:
          action.payload.page === 1
            ? initialState.nextTokens
            : state.nextTokens,
        nextToken: null,
        serviceAddonsLoading: true,
        serviceAddonsError: null,
      };
    case "LIST_AVAILABLE_ADD_ONS_SUCCESS":
      return {
        ...state,
        serviceAddons: action.payload.serviceAddons,
        nextTokens: {
          ...state.nextTokens,
          [action.payload.nextPage]: action.payload.nextToken,
        },
        serviceAddonsLoading: false,
        request: null,
      };
    case "LIST_AVAILABLE_ADD_ONS_CANCEL":
      return {
        ...state,
        serviceAddonsLoading: false,
        serviceAddonsError: null,
        request: null,
      };
    case "LIST_AVAILABLE_ADD_ONS_ERROR":
      return {
        ...state,
        serviceAddonsLoading: false,
        serviceAddonsError: action.error,
        request: null,
      };
    case "REQUEST_UPDATE_SERVICE_ADDON":
      return {
        ...state,
        addOnId: "",
        updateServiceAddOnError: null,
        updateServiceAddOnLoading: true,
      };
    case "UPDATE_SERVICE_ADDON_SUCCESS":
      const { addOn } = action.payload;
      const updatedServiceAddOns = state.serviceAddons.map((serviceAddOn) =>
        serviceAddOn.id === addOn.id ? addOn : serviceAddOn
      );
      return {
        ...state,
        addOnId: addOn.id,
        updateServiceAddOnLoading: false,
        serviceAddons: updatedServiceAddOns,
      };
    case "ERROR_UPDATE_SERVICE_ADDON":
      return {
        ...state,
        updateServiceAddOnLoading: false,
        updateServiceAddOnError: action.error,
      };
    case "REQUEST_CREATE_SERVICE_ADDON":
      return {
        ...state,
        newServiceAddOn: "",
        newServiceAddOnError: null,
        newServiceAddOnLoading: true,
      };
    case "SUCCESS_CREATE_SERVICE_ADDON":
      return {
        ...state,
        newServiceAddOn: action.payload.addOn,
        serviceAddons: [...state.serviceAddons, action.payload.addOn],
        newServiceAddOnLoading: false,
      };
    case "ERROR_CREATE_SERVICE_ADDON":
      return {
        ...state,
        newServiceAddOnLoading: false,
        newServiceAddOnError: action.error,
      };
    case "REQUEST_DELETE_SERVICE_ADDON":
      return {
        ...state,
        request: action.payload.request,
        deleteServiceAddOnLoading: true,
        deleteServiceAddOnError: null,
        deletedAddOnID: "",
      };
    case "DELETE_SERVICE_ADDON_SUCCESS":
      return {
        ...state,
        request: null,
        deleteServiceAddOnLoading: false,
        deletedAddOnID: action.payload.serviceAddOnID,
        serviceAddons: state.serviceAddons.filter(
          (serviceAddon) => serviceAddon.id !== action.payload.serviceAddOnID
        ),
      };
    case "DELETE_SERVICE_ADDON_CANCEL":
      return {
        ...state,
        deleteServiceAddOnLoading: false,
        deleteServiceAddOnError: null,
        request: null,
      };
    case "DELETE_SERVICE_ADDON_ERROR":
      return {
        ...state,
        request: null,
        deleteServiceAddOnLoading: false,
        deleteServiceAddOnError: action.error,
      };
    case "REQUEST_LIST_PROVINCES":
      return {
        ...state,
        request: action.payload.request,
        provinces: [],
        provincesLoading: true,
        provincesError: null,
      };
    case "LIST_PROVINCES_SUCCESS":
      return {
        ...state,
        request: null,
        provinces: action.payload.provinces,
        provincesLoading: false,
      };
    case "LIST_PROVINCES_ERROR":
      return {
        ...state,
        request: null,
        provincesLoading: false,
        provincesError: action.error,
      };
    case "CLEAR_UPDATE_BUSINESS_SERVICE":
      return {
        ...state,
        businessServiceID: "",
        businessService: {},
        deletedID: "",
      };
    case "CLEAR_UPDATE_SERVICE_ADDON_ERROR":
      return {
        ...state,
        updateServiceAddOnError: null,
        newServiceAddOnError: null,
        deleteServiceAddOnError: null,
      };
    case "CLEAR_UPDATE_SERVICE_ADDON":
      return {
        ...state,
        addOnId: "",
        newServiceAddOn: "",
        deletedAddOnID: "",
      };
    case "CLEAR_UPDATE_BUSINESS_SERVICE_ERROR":
      return {
        ...state,
        businessServiceUpdateError: null,
        businessServiceCreateError: null,
        businessServiceDeleteError: null,
      };
    default:
      return state;
  }
};
